import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {Observable} from "rxjs";
import {first, take} from "rxjs/operators";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class AffiliateLinkService {

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }


  public delete(uuid: string): Observable<Uuid>  {
    return this.httpClient.delete(`/rest/crm/affiliate-link/${uuid}`)
      .pipe(first()) as Observable<Uuid>;
  }

}
